'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WixSDKProviderApi = function () {
  function WixSDKProviderApi(wixApi) {
    (0, _classCallCheck3.default)(this, WixSDKProviderApi);

    this.wixApi = wixApi;
  }

  (0, _createClass3.default)(WixSDKProviderApi, [{
    key: 'getAnonymousUserId',
    value: function getAnonymousUserId() {
      return this.wixApi.Utils.getInstanceValue('aid');
    }
  }, {
    key: 'getViewMode',
    value: function getViewMode() {
      return this.wixApi.Utils.getViewMode();
    }
  }, {
    key: 'attachEditModeChanged',
    value: function attachEditModeChanged(callback) {
      this.wixApi.removeEventListener(this.wixApi.Events.EDIT_MODE_CHANGE, callback);
    }
  }, {
    key: 'dettachEditModeChanged',
    value: function dettachEditModeChanged(callback) {
      this.wixApi.removeEventListener(this.wixApi.Events.EDIT_MODE_CHANGE, callback);
    }
  }, {
    key: 'getCurrentPageId',
    value: function getCurrentPageId() {
      var _this = this;

      return new _promise2.default(function (resolve) {
        _this.wixApi.getCurrentPageId(function (currentPageId) {
          resolve(currentPageId);
        });
      });
    }
  }, {
    key: 'getSitePages',
    value: function getSitePages() {
      var _this2 = this;

      return new _promise2.default(function (resolve) {
        _this2.wixApi.getSitePages(function (arrPages) {
          resolve(arrPages);
        });
      });
    }
  }, {
    key: 'replaceSectionState',
    value: function replaceSectionState(state) {
      this.wixApi.replaceSectionState(state);
    }
  }, {
    key: 'navigateToPage',
    value: function navigateToPage(pageId) {
      this.wixApi.navigateToPage(pageId);
    }
  }, {
    key: 'getSiteInfo',
    value: function getSiteInfo() {
      var _this3 = this;

      return new _promise2.default(function (resolve) {
        _this3.wixApi.getSiteInfo(function (info) {
          resolve(info);
        });
      });
    }
  }, {
    key: 'getSectionUrl',
    value: function getSectionUrl(sectionId) {
      var _this4 = this;

      return new _promise2.default(function (resolve) {
        _this4.wixApi.Utils.getSectionUrl({ sectionId: sectionId }, function (data) {
          resolve(data);
        });
      });
    }
  }, {
    key: 'getDashboardAppUrl',
    value: function getDashboardAppUrl() {
      var _this5 = this;

      return new _promise2.default(function (resolve) {
        _this5.wixApi.Settings.getDashboardAppUrl(function (url) {
          resolve(url);
        });
      });
    }
  }, {
    key: 'applicationLoaded',
    value: function applicationLoaded() {
      this.wixApi.Performance.applicationLoaded();
    }
  }, {
    key: 'getLocale',
    value: function getLocale() {
      return this.wixApi.Utils.getLocale();
    }
  }, {
    key: 'getDeviceType',
    value: function getDeviceType() {
      return this.wixApi.Utils.getDeviceType();
    }
  }, {
    key: 'getBiToken',
    value: function getBiToken() {
      return this.wixApi.Utils.getInstanceValue('biToken');
    }
  }, {
    key: 'isStyleChanged',
    value: function isStyleChanged(type) {
      return type === this.wixApi.Events.STYLE_PARAMS_CHANGE;
    }
  }, {
    key: 'isVisualFocusEnabled',
    value: function isVisualFocusEnabled() {
      var _this6 = this;

      return new _promise2.default(function (resolve) {
        if (_this6.wixApi && typeof _this6.wixApi.isVisualFocusEnabled === 'function') {
          try {
            _this6.wixApi.isVisualFocusEnabled(function (isEnabled) {
              resolve(isEnabled);
            });
          } catch (error) {
            resolve(false);
          }
        } else {
          resolve(false);
        }
      });
    }
  }, {
    key: 'getColorByreference',
    value: function getColorByreference(strColor) {
      return this.wixApi.Styles.getColorByreference(strColor);
    }
  }, {
    key: 'getStyleFontByReference',
    value: function getStyleFontByReference(strColor) {
      return this.wixApi.Styles.getStyleFontByReference(strColor);
    }
  }, {
    key: 'getEditorFonts',
    value: function getEditorFonts() {
      return this.wixApi.Styles.getEditorFonts();
    }
  }]);
  return WixSDKProviderApi;
}();

exports.default = WixSDKProviderApi;